import React from "react";
import { hideScrollbar } from "../../lib/styles/styleLibrary";
import {
	SplitLeft,
	SplitPaneContent,
	SplitPaneWrapper,
	SplitRight,
} from "./component";

const SplitPane = (props) => {
	return (
		<SplitPaneWrapper
			css={hideScrollbar}
			mainHeightAdjust={props.mainHeightAdjust}>
			<SplitPaneContent direction={props.wrapDirection}>
				<SplitLeft
					css={hideScrollbar}
					leftHeightAdjust={props.leftHeightAdjust}>
					{props.left}
				</SplitLeft>
				{props.right && (
					<SplitRight
						css={hideScrollbar}
						hide={props.hideRightSide}
						rightHeightAdjust={props.rightHeightAdjust}>
						{props.right}
					</SplitRight>
				)}
			</SplitPaneContent>
		</SplitPaneWrapper>
	);
};

export default SplitPane;
